export const PAYMENT_STATUS_PENDING_ID = '507f1f77bcf86cd799439031';
export const PAYMENT_STATUS_PENDING_LABEL = 'Pending';

export const PAYMENT_STATUS_PENDING = {
    _id: PAYMENT_STATUS_PENDING_ID,
    label: PAYMENT_STATUS_PENDING_LABEL,
};

export const PAYMENT_STATUS_COMPLETED_ID = '507f1f77bcf86cd799439032';

export const PAYMENT_TYPE_INDIVIDUAL = {
    _id: '507f1f77bcf86cd799439035',
    label: 'Individual',
};
